export const NONDELIVERYREASONS_REQUEST = "NONDELIVERYREASONS_REQUEST";
export const NONDELIVERYREASONS_SUCCESS = "NONDELIVERYREASONS_SUCCESS";
export const NONDELIVERYREASONS_ERROR = "NONDELIVERYREASONS_ERROR";
export const NONDELIVERYREASONS_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppNonDeliveryReasonV1',
    size: 1000
};

export const NONDELIVERYSOLUTION_REQUEST = "NONDELIVERYSOLUTION_REQUEST";
export const NONDELIVERYSOLUTION_SUCCESS = "NONDELIVERYSOLUTION_SUCCESS";
export const NONDELIVERYSOLUTION_ERROR = "NONDELIVERYSOLUTION_ERROR";
export const NONDELIVERYSOLUTION_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'AppNonDeliverySolutionV1',
    size: 1000
};

export const NONDELIVERYPOST_REQUEST = "NONDELIVERYPOST_REQUEST";
export const NONDELIVERYPOST_SUCCESS = "NONDELIVERYPOST_SUCCESS";
export const NONDELIVERYPOST_ERROR = "NONDELIVERYPOST_ERROR";
export const CLEARNONDELIVERYPOSTSTATUS = "CLEARNONDELIVERYPOSTSTATUS";
export const NONDELIVERYPOST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'NonDeliveryV1',
    parameters: []
};

export const SOLVENONDELIVERY_REQUEST = "SOLVENONDELIVERY_REQUEST";
export const SOLVENONDELIVERY_SUCCESS = "SOLVENONDELIVERY_SUCCESS";
export const SOLVENONDELIVERY_ERROR = "SOLVENONDELIVERY_ERROR";
export const CLEARSOLVENONDELIVERYSTATUS = "CLEARSOLVENONDELIVERYSTATUS";
export const SOLVENONDELIVERYPOST_params = {
    key: process.env.VUE_APP_API_KEY,
    connector: 'NonDeliverySolvedV1',
    parameters: []
};